export default __webpack_public_path__ + "static/ekstrakt_logo-846bbfd2b301a8668c9656976b3bfcf2.svg";